const positions = ['top', 'bottom'];

export default positions;
